import { Drawer } from '@zorro/design-system/v2/Drawer';
import { Modal } from '@zorro/design-system/v2/Modal';
import { isDevelopmentEnvironment } from '@zorro/environment';
import { useDisclosure, useHotkeys } from '@zorro/web/design-system';
import { useRoles } from '@zorro/web/ui-utils';

import { ShareSupportInformationForm } from './ShareSupportInformationForm';
import { ShareSupportInformationOperationsForm } from './ShareSupportInformationOperationsForm';

export const SupportInformation = () => {
  const { isZorroOperations } = useRoles();

  const [opened, { close, toggle }] = useDisclosure();

  useHotkeys([['mod+shift+P', toggle, { preventDefault: true }]]);

  if (typeof window === 'undefined') {
    return null;
  }

  if (isZorroOperations || isDevelopmentEnvironment()) {
    return (
      <Drawer opened={opened} title="Support Information" onClose={close}>
        <ShareSupportInformationOperationsForm onClose={close} />
      </Drawer>
    );
  }

  return (
    <Modal
      isOpen={opened}
      onClose={close}
      title="Send session details to Zorro Support?"
      size="lg"
    >
      <ShareSupportInformationForm onClose={close} />
    </Modal>
  );
};
